import editSchema from "../../getters/editSchema";

const mermaid = editSchema;
export default mermaid;
